<template>
  <div class="ui-btn ui-btn-share" @click="handleClick">
    <i class="icon-share"></i>
    <span>分享作品</span>
  </div>
</template>

<script>
export default {
  name: "uiBtnShare",
  methods: {
    handleClick(e) {
      this.$emit("shareWorkDetail", e)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-btn-share {
  width: 3rem;
  height: 0.98rem;
  background: url("../../../../assets/images/sharepage_btn_bg.png") no-repeat center;
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:active {
    opacity: 0.7;
  }
  .icon-share {
    margin-right: 0.08rem;
    width: 0.34rem;
    height: 0.34rem;
    background: url("../../../../assets/images/icon_share@1x.png") no-repeat center;
    background-size: 100%;
  }
}
</style>
